/**
 * @generated SignedSource<<e0a773609de5d6db401773b58f38ae2e>>
 * @relayHash 73501f47770cafb99e320a631589771b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 841478951b69bd80611e4685c35355d42da36f22e330b184838aaa5a3632bfff

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type multiSelect_multiSelectSearchQuery$variables = {
  id: string;
};
export type multiSelect_multiSelectSearchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"multiSelect_issueFieldMultiSelectEditviewFull_MultiSelectEditViewWithFieldOptionsFragment">;
};
export type multiSelect_multiSelectSearchQuery = {
  response: multiSelect_multiSelectSearchQuery$data;
  variables: multiSelect_multiSelectSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v2 = {
  "kind": "Literal",
  "name": "searchBy",
  "value": ""
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  (v2/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "multiSelect_multiSelectSearchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "multiSelect_issueFieldMultiSelectEditviewFull_MultiSelectEditViewWithFieldOptionsFragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "multiSelect_multiSelectSearchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/)
        ],
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "value",
                            "kind": "ScalarField",
                            "name": "id"
                          },
                          {
                            "alias": "label",
                            "kind": "ScalarField",
                            "name": "value"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "optionId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isDisabled"
                          },
                          (v5/*: any*/),
                          (v3/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ],
                "storageKey": "fieldOptions(first:100,searchBy:\"\")"
              },
              {
                "args": (v4/*: any*/),
                "filters": [
                  "searchBy",
                  "filterById"
                ],
                "handle": "connection",
                "key": "multiSelect_issueFieldMultiSelectEditviewFull_fieldOptions",
                "kind": "LinkedHandle",
                "name": "fieldOptions"
              }
            ],
            "type": "JiraMultipleSelectField"
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "841478951b69bd80611e4685c35355d42da36f22e330b184838aaa5a3632bfff",
    "metadata": {},
    "name": "multiSelect_multiSelectSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "170b625685e90c09b57edc6e6886d85c";

export default node;
